/**
 * Storage & Header Constants
 * STORAGE_KEYS: sessionStorage key names (prefixed einv_) for auth tokens,
 * session data, group keys, and user profile.
 * API_HEADERS: canonical header names attached by API client interceptors.
 */

export const STORAGE_KEYS = Object.freeze({
  GROUP_KEY: "einv_group_key",
  GROUP_KEY_ACCOUNT_NAME: "einv_group_key_account_name",
  AUTH_TOKEN: "einv_auth_token",
  REFRESH_TOKEN: "einv_refresh_token",
  USER_PROFILE: "einv_user_profile",
  FLOW_SESSION: "einv_flow_session",
  BOOTSTRAP_TOKEN: "einv_bootstrap_token",
  DATASET_ID: "einv_dataset_id",
  CONNECTION_USER_VERIFICATION: "einv_connection_user_verification"
});

export const API_HEADERS = Object.freeze({
  X_DATASET_ID: "X-Dataset-Id",
  AUTHORIZATION: "Authorization",
  CONTENT_TYPE: "Content-Type",
  APPLICATION_NAME: "X-Application-Name"
});
